/* eslint-disable no-shadow */

export enum GoodsMovementTypeEnum {
  DESCONHECIDO = 0,
  NAO = 1,
  VINCULADA_DECLARACAO_IMPORTACAO = 2,
  VINCULADA_DECLARACAO_EXPORTACAO = 3,
}

export const GoodsMovementTypeLabels: Record<number, string> = {
  [GoodsMovementTypeEnum.DESCONHECIDO]: "Desconhecido",
  [GoodsMovementTypeEnum.NAO]: "Não",
  [GoodsMovementTypeEnum.VINCULADA_DECLARACAO_IMPORTACAO]:
    "Vinculada à Declaração de Importação",
  [GoodsMovementTypeEnum.VINCULADA_DECLARACAO_EXPORTACAO]:
    "Vinculada à Declaração de Exportação",
};

export const GoodsMovementTypeList = [
  {
    value: GoodsMovementTypeEnum.DESCONHECIDO,
    label: GoodsMovementTypeLabels[GoodsMovementTypeEnum.DESCONHECIDO],
  },
  {
    value: GoodsMovementTypeEnum.NAO,
    label: GoodsMovementTypeLabels[GoodsMovementTypeEnum.NAO],
  },
  {
    value: GoodsMovementTypeEnum.VINCULADA_DECLARACAO_IMPORTACAO,
    label:
      GoodsMovementTypeLabels[
        GoodsMovementTypeEnum.VINCULADA_DECLARACAO_IMPORTACAO
      ],
  },
  {
    value: GoodsMovementTypeEnum.VINCULADA_DECLARACAO_EXPORTACAO,
    label:
      GoodsMovementTypeLabels[
        GoodsMovementTypeEnum.VINCULADA_DECLARACAO_EXPORTACAO
      ],
  },
];
